import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ActionType,
} from "../services/types/ComponentTypes";

const EMP_SUMMARY_QUERY =
  "SELECT e.id, e.name, e.mobile, e.group_id, COALESCE(u.username, NULLIF(TRIM(e.created_by::text), '')) AS created_by, e.created_at FROM employee e LEFT JOIN users u ON u.id::text = TRIM(e.created_by::text) WHERE e.soft_delete = 0 AND e.branch_id = '<branch_id>' ORDER BY e.created_at DESC";

export const screen_108_employee: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    screenId: "108",
    fabAction: {
      type: "add",
      permissionKey: "Add",
      screenId: "122",
      action: "modulev1/emp_add",
    },
    title: "Employees",
    style: {
      backgroundColor: "#F9FAFB",
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12,
          padding: 16,
        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "name",
            Name: "emp_summary",
            SummeryActions: [
              {
                Action: {
                  Action: "Navigate",
                  Navigate: "modulev1/emp_add/<id>",
                },
                ActionType: "View",
                ScreenId: "122",
                tooltip: "View",
              },
              {
                Action: {
                  Action: "Navigate",
                  Navigate: "modulev1/emp_add/<id>",
                },
                ActionType: "Edit",
                permissionKey: "Edit",
                ScreenId: "122",
              },
              {
                Action: {
                  Action: "Delete",
                  Module: "emp_summary",
                },
                ActionType: "Delete",
                permissionKey: "Delete",
                ScreenId: "108",
              },
              {
                Action: {
                  Action: "PDF",
                  Settings: "employee_details",
                },
                ActionType: ActionType.PDF_DOWNLOAD,
                tooltip: "Download PDF",
              },
            ],
            Form: {
              Name: "emp_summary",
              TableName: "employee",
              Query: EMP_SUMMARY_QUERY,
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
                {
                  IncludeLabel: true,
                  Label: "Name",
                  BindValue: "txt_name",
                  Json_Attribute: "name",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Mobile",
                  BindValue: "txt_mobile",
                  Json_Attribute: "mobile",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Group",
                  IsMandatory: true,
                  BindValue: "drp_group",
                  Json_Attribute: "group_id",
                  componentType: ComponentType.SELECT_DROPDOWN,
                  showInSummary: true,
                  LookupName: "employee_group",
                },
                {
                  IncludeLabel: true,
                  Label: "Created by",
                  BindValue: "txt_created_by",
                  Json_Attribute: "created_by",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Created at",
                  BindValue: "txt_created_at",
                  Json_Attribute: "created_at",
                  componentType: ComponentType.DATETIME_FIELD,
                  showInSummary: true,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];
